module.exports = __webpack_public_path__ + "static/media/GoogleDA-2.1f6e2022.jpg";